
































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Inairthreshold from "../../../store/entities/moisturethreshold";
@Component
export default class CreateInairthreshold extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  moisturethreshold: Inairthreshold = new Inairthreshold();
  idisable:boolean = false;
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  save() {
    (this.$refs.moisturethresholdForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true;
        await this.$store.dispatch({
          type: "moisturethreshold/create",
          data:this.moisturethreshold
        });
        (this.$refs.moisturethresholdForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel(){
            (this.$refs.moisturethresholdForm as any).resetFields();
            this.$emit('input',false);
        }
  moisturethresholdRule = {
    tName: [{ required: true, message: "请填写阈值方案名称", trigger: "blur" }],
    MAX_moisture: [{required: true, message: "请填写水分最大值", trigger: "blur" }],
    MIN_moisture: [{required: true, message: "请填写水分最小值", trigger: "blur" }],
  };
}
